import { format } from 'date-fns';

const getMonthAndYear = (date: Date) => format(date, 'MMMM yyyy');
const getMonth = (date: Date) => format(date, 'MMMM');

export const formatInterval = (start: Date, end: Date) => {
  // different years
  if (start.getFullYear() !== end.getFullYear()) {
    return `${getMonthAndYear(start)} - ${getMonthAndYear(end)}`;
  }

  // different months
  if (start.getMonth() !== end.getMonth()) {
    return `${getMonth(start)} - ${getMonthAndYear(end)}`;
  }

  return getMonthAndYear(start);
};
